// src/locales/certificate-en.ts
export default {
    navigation: {
        certificates: 'License Management',
        certificateDashboard: 'Dashboard',
        licenseTypes: 'License Types',
        vietrroCertificate: 'Vietrro License',
        wipoCertificate: 'WIPO License',
        noipCertificate: 'NOIP License',
        associationLicenses: 'Association Licenses',
        licenseProcess: 'License Process',
        licenseApplication: 'License Application',
        licenseTracking: 'Track Progress',
        licenseApproval: 'License Approval',
        licenseHistory: 'License History',
        integrations: 'Integrations',
        wipoIntegration: 'WIPO Integration',
        vietrroIntegration: 'Vietrro Integration',
        noipIntegration: 'NOIP Integration',
        associationIntegration: 'Association Integration',
        certificateVerification: 'Certificate Verification'
    },
    dashboard: {
        title: 'License Dashboard',
        subtitle: 'Manage licenses and certificates from organizations',
        stats: {
            totalApplications: 'Total Applications',
            pendingApplications: 'Pending Applications',
            activeCertificates: 'Active Certificates',
            expiredCertificates: 'Expired'
        },
        quickActions: {
            title: 'Quick Actions',
            newApplication: 'New License Application',
            newApplicationDesc: 'Create new license application',
            vietrroCert: 'Vietrro License',
            vietrroCertDesc: 'Issue official license',
            tracking: 'Track Progress',
            trackingDesc: 'View application status',
            verification: 'Verify License',
            verificationDesc: 'Check validity'
        },
        recent: {
            applications: 'Recent Applications',
            certificates: 'Recent Certificates',
            viewAll: 'View All',
            noApplications: 'No applications yet',
            noCertificates: 'No certificates yet'
        },
        distribution: {
            title: 'Distribution by License Type'
        }
    },
    application: {
        title: 'New License Application',
        subtitle: 'Create a license application for your work',
        steps: {
            contentSelection: 'Select Content',
            certificateType: 'License Type',
            applicationDetails: 'Application Details',
            reviewSubmit: 'Review & Submit'
        },
        contentSelection: {
            title: 'Select work for license application',
            subtitle: 'Choose a work from your content list',
            noContent: 'You have no registered works yet.',
            registerNew: 'Register new work'
        },
        certificateType: {
            title: 'Choose license type',
            subtitle: 'Select the license type that suits your needs',
            types: {
                vietrro: {
                    name: 'Vietrro License',
                    description: 'Official license from Vietrro, valid in Vietnam'
                },
                wipo: {
                    name: 'WIPO Connect License',
                    description: 'International license from World Intellectual Property Organization'
                },
                noip: {
                    name: 'NOIP License',
                    description: 'License from National Office of Intellectual Property of Vietnam'
                },
                association: {
                    name: 'Association License',
                    description: 'License from specialized associations'
                }
            },
            recommended: 'Recommended'
        },
        details: {
            title: 'Application Details',
            subtitle: 'Fill in detailed information about the work and copyright',
            workTitle: 'Work Title',
            workType: 'Work Type',
            description: 'Work Description',
            firstPublicationDate: 'First Publication Date',
            creators: {
                title: 'Creators',
                add: '+ Add Creator',
                name: 'Creator Name',
                role: 'Role',
                percentage: '% Rights',
                remove: 'Remove',
                empty: 'No creators added yet'
            },
            required: 'Required field'
        },
        review: {
            title: 'Review Application Information',
            subtitle: 'Review information before submitting application',
            importantNotes: {
                title: 'Important Notes',
                processing: 'Application will be processed within 5-10 business days',
                notification: 'You will receive email notification about processing results',
                fee: 'Processing fee will be notified after application approval'
            }
        },
        buttons: {
            previous: 'Previous',
            continue: 'Continue',
            submit: 'Submit Application'
        }
    },
    status: {
        draft: 'Draft',
        submitted: 'Submitted',
        under_review: 'Under Review',
        approved: 'Approved',
        rejected: 'Rejected',
        active: 'Active',
        expired: 'Expired',
        revoked: 'Revoked'
    },
    verification: {
        title: 'Certificate Verification',
        enterNumber: 'Enter certificate number',
        verify: 'Verify',
        result: {
            valid: 'Valid certificate',
            invalid: 'Invalid certificate',
            expired: 'Certificate expired',
            notFound: 'Certificate not found'
        }
    },
    errors: {
        createApplication: 'Cannot create application',
        submitApplication: 'Cannot submit application',
        loadApplications: 'Cannot load applications',
        loadCertificates: 'Cannot load certificates',
        loadStats: 'Cannot load statistics',
        verifyCertificate: 'Cannot verify certificate',
        registerWipo: 'Cannot register with WIPO',
        registerNoip: 'Cannot register with NOIP',
        registerAssociation: 'Cannot register with association'
    },
    certificateDetail: {
        id: "ID Certificate",
        code: "Mã Certificate",
        issuingAuthority: "Issuing Authority",
        status: {
            active: {
                title: "Active",
                subTitle: "This certificate is currently valid"
            },
            pending: {
                title: "Pending",
                subTitle: "The application is under review"
            },
            expired: {
                title: "Expired",
                subTitle: "The certificate is no longer valid"
            },
            revoked: {
                title: "Revoked",
                subTitle: "The certificate has been revoked"
            },
            default: {
                title: "Undefined",
                subTitle: ""
            }
        }
    }
};